import React from 'react';
import { ProtectedPermissionRoute, ProtectedAdminRoute } from '@nimbitlabs/auth';
import { AuditLog } from './AuditLog';

export const auditRoutes = [
  { 
    path: '/audit', 
    element: <ProtectedAdminRoute><ProtectedPermissionRoute element={<AuditLog />} permission="audit:read" /></ProtectedAdminRoute>, 
    permission: 'audit:read' 
  },
];
